import React from "react";
import { useHistory } from "react-router";
import Link from "@material-ui/core/Link";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider";
import { FINALIZE_PAGE } from "../../Routing/routes";

interface IProps {
  rootClass: any;
  textClass: any;
}

const FinalizeButton: React.FC<IProps> = ({ rootClass, textClass }: IProps) => {
  const history = useHistory();

  const handleChnageFacility = () => {
    history.push(FINALIZE_PAGE);
  };

  return (
    <React.Fragment>
      <Link onClick={() => handleChnageFacility()} component={"li"} style={{ textDecoration: "none" }}>
        <ListItem button classes={{ root: rootClass }} style={{marginTop: 10}}>
          <ListItemText classes={{ primary: textClass }} primary={"Finalizacja"} />
        </ListItem>
        <Divider />
      </Link>
    </React.Fragment>
  );
};

export default FinalizeButton;
